import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Get Account Managers List API Call
 * @returns {Promise<Object>} - Response data containing list of account managers
 */
export const getAccountManagersList = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.ACCOUNT_MANAGERS_LIST);
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 